var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : 'button',{tag:"component",staticClass:"dropdown-item",class:[_vm.isActive && 'dropdown-item--active'],attrs:{"to":_vm.to || null},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }